import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Modal, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import CustomToggle from '../../../components/dropdowns'
import ReactFsLightbox from 'fslightbox-react';
import ShareOffcanvas from '../../../components/share-offcanvas'
import Loader from "react-js-loader";
import { InView } from "react-intersection-observer";

import { Link, useNavigate, Route } from 'react-router-dom'
import { ToastProvider, useToasts } from 'react-toast-notifications';
import Swal from 'sweetalert2'
import { apiHandler } from '../../../api/apihandler';
import { BLOCK_UNBLOCK_FOLLOWER, USER_FOLLOW_REQUEST, PROFILE_DETAILS } from "../../../api/constants";
import Moment from 'moment';
import { useParams } from "react-router-dom"
import { useSelector } from 'react-redux';
import { isTeacherLoginProfile } from '../../../utilities/teacherModulePermissions';

// images
import img1 from '../../../assets/images/page-img/profile-bg1.jpg'
import img5 from '../../../assets/images/icon/10.png'
import user1 from '../../../assets/images/user/1.jpg'
import user05 from '../../../assets/images/user/05.jpg'
import user02 from '../../../assets/images/user/02.jpg'
import user03 from '../../../assets/images/user/03.jpg'
import user06 from '../../../assets/images/user/06.jpg'
import user07 from '../../../assets/images/user/07.jpg'
import user08 from '../../../assets/images/user/08.jpg'
import user09 from '../../../assets/images/user/09.jpg'
import user10 from '../../../assets/images/user/10.jpg'
import icon1 from '../../../assets/images/icon/01.png'
import icon2 from '../../../assets/images/icon/02.png'
import icon3 from '../../../assets/images/icon/03.png'
import icon4 from '../../../assets/images/icon/04.png'
import icon5 from '../../../assets/images/icon/05.png'
import icon6 from '../../../assets/images/icon/06.png'
import icon7 from '../../../assets/images/icon/07.png'
import icon8 from '../../../assets/images/icon/08.png'
import icon9 from '../../../assets/images/icon/09.png'
import icon10 from '../../../assets/images/icon/10.png'
import icon11 from '../../../assets/images/icon/11.png'
import icon12 from '../../../assets/images/icon/12.png'
import icon13 from '../../../assets/images/icon/13.png'
import g1 from '../../../assets/images/page-img/g1.jpg'
import g2 from '../../../assets/images/page-img/g2.jpg'
import g3 from '../../../assets/images/page-img/g3.jpg'
import g4 from '../../../assets/images/page-img/g4.jpg'
import g5 from '../../../assets/images/page-img/g5.jpg'
import g6 from '../../../assets/images/page-img/g6.jpg'
import g7 from '../../../assets/images/page-img/g7.jpg'
import g8 from '../../../assets/images/page-img/g8.jpg'
import g9 from '../../../assets/images/page-img/g9.jpg'
import img56 from '../../../assets/images/page-img/p2.jpg'
import img58 from '../../../assets/images/page-img/p1.jpg'
import img57 from '../../../assets/images/page-img/p3.jpg'
import small07 from '../../../assets/images/small/07.png'
import small08 from '../../../assets/images/small/08.png'
import small09 from '../../../assets/images/small/09.png'
import small1 from '../../../assets/images/small/07.png'
import small2 from '../../../assets/images/small/08.png'
import small3 from '../../../assets/images/small/09.png'
import small4 from '../../../assets/images/small/10.png'
import small5 from '../../../assets/images/small/11.png'
import small6 from '../../../assets/images/small/12.png'
import small7 from '../../../assets/images/small/13.png'
import small8 from '../../../assets/images/small/14.png'
import user9 from '../../../assets/images/user/1.jpg'
import img59 from '../../../assets/images/page-img/59.jpg'
import loader from '../../../assets/images/page-img/page-load-loader.gif'
import FeedsList from '../../../components/feeds/feedsList';
import GalleryImageCard from '../../../components/gallery/galleryImageCard';


// Fslightbox plugin
const FsLightbox = ReactFsLightbox.default ? ReactFsLightbox.default : ReactFsLightbox;

const FriendProfile = () => {
   const { slug } = useParams();
   //console.log("slug", slug)

   const [show, setShow] = useState(false);
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);
   const navigate = useNavigate();
   const { addToast } = useToasts();
   const loggedInUserData = useSelector((state) => state.setting.setting.user_data);
   const currentViewer = loggedInUserData ? JSON.parse(loggedInUserData) : null;
   const [profileData, setProfileData] = useState('');
   const [organizationInfo, setOrganizationInfo] = useState(null);
   const [secureActiveTab, setSecureActiveTab] = useState('About');
   const [isFollowing, setIsFollowing] = useState(0);
   const [isFollower, setIsFollower] = useState(0);
   const [isBlocked, setIsBlocked] = useState(0);
   const [followRequestStatus, setFollowRequestStatus] = useState('none'); // 'none', 'pending', 'accepted'
   
   const [showLoader, setShowLoader] = useState(false);

   const [imageController, setImageController] = useState({
      toggler: false,
      slide: 1
   });

   function imageOnSlide(number) {
      setImageController({
         toggler: !imageController.toggler,
         slide: number
      });
   }

   const [isFirst, setIsFirst] = useState(true);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setIsFirst(false)
    }, [isFirst]);

   // Ensure secure active tab defaults to a valid tab
   useEffect(() => {
      const validSecureTabs = ['Timeline', 'About', 'Family', 'Media', 'Documents'];
      if (!validSecureTabs.includes(secureActiveTab)) {
         setSecureActiveTab('About');
      }
   }, [secureActiveTab]);

   useEffect(() => {
      if (localStorage.getItem("uzoneAuthToken")) {
         // Clear the previous profile immediately so a stray click during
         // the fetch (e.g. Follow) can't fire against the last-viewed
         // user's id instead of the one the URL now points to.
         setProfileData('')
         setIsFollowing(0)
         setIsFollower(0)
         setIsBlocked(0)
         setFollowRequestStatus('none')
         getProfileDetails()
      } else {
         navigate('/')
      }
      // Re-fetch whenever the route's slug changes - this component doesn't
      // remount when navigating from one friend's profile straight to
      // another (e.g. clicking a link in a followers list), so without
      // `slug` in the deps, profileData (and everything derived from it,
      // like the follow/unfollow button's follow_button_show check) kept
      // showing whichever profile loaded first in the session.
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [slug]);

   async function isNumber(n) { return !isNaN(parseFloat(n)) && !isNaN(n - 0) }
   async function getProfileDetails() {
      try {
         let dynamicParams = null
         if(await isNumber(slug)){
            //console.log("this is number")
            dynamicParams = {
               user_id: slug
            }
         } else{
            //console.log("this is string")
            dynamicParams = {
               slug: slug
            }
         }
         const res = await apiHandler(PROFILE_DETAILS, "POST", dynamicParams)
         if (res.data?.response?.status === 200) {
            console.log("Profile Details Response:", res?.data?.data?.user)
            setIsFollowing(res?.data?.data?.user?.is_following)
            setIsFollower(res?.data?.data?.user?.is_follower)
            setIsBlocked(res?.data?.data?.user?.is_blocked)
            // The API reports a pending follow request as is_pending: 1 -
            // fall back to follow_request_status for any older response
            // shape that still sends that instead.
            const pendingFromApi = res?.data?.data?.user?.is_pending === 1 || res?.data?.data?.user?.is_pending === true;
            setFollowRequestStatus(pendingFromApi ? 'pending' : (res?.data?.data?.user?.follow_request_status || 'none'))
            setProfileData(res?.data?.data?.user)
            setOrganizationInfo(res?.data?.data?.organization_info || null)
            console.log("Follow Status - isFollowing:", res?.data?.data?.user?.is_following, "isPending:", res?.data?.data?.user?.is_pending)
         } else {
            //navigate('/auth/sign-in')
            addToast(res?.response?.data?.data?.message, { appearance: 'error' });
            //console.log("profileRes",res)
         }
      } catch (error) {
         console.error(error);
      }
      finally {
      }
   }

   // Admin accounts (user_type 2) can't be unfollowed - block the action
   // client-side with an explanatory alert rather than letting the request
   // go out and fail (or silently succeed against the user's expectations).
   function handleUnfollowClick() {
      if (Number(profileData?.user_type) === 2) {
         Swal.fire({
            icon: 'info',
            title: 'Unable to Unfollow',
            text: 'This is an admin account and cannot be unfollowed.',
            confirmButtonText: 'Okay'
         });
         return;
      }
      getFollowUnfollow(profileData?.id, 0);
   }

   async function getFollowUnfollow(followerId, isFollowingVal) {
      try {
         const res = await apiHandler(USER_FOLLOW_REQUEST, "POST", {
            follower_id: followerId
         })
         console.log('Follow/Unfollow response:', res)
         if (res.data?.response?.status === 200) {
            if (isFollowingVal === 1) {
               // Sending follow request
               setFollowRequestStatus('pending')
               addToast('Follow request sent!', { appearance: 'success' });
            } else {
               // Canceling follow request or unfollowing
               setIsFollowing(0)
               setFollowRequestStatus('none')
               addToast('Request cancelled successfully!', { appearance: 'success' });
            }
            // Refresh profile data to get updated status
            getProfileDetails()
         } else {
            console.error('API Error:', res)
            addToast(res?.response?.data?.data?.message || 'Something went wrong', { appearance: 'error' });
         }
      } catch (error) {
         console.error('Follow error:', error);
         addToast('Failed to process request', { appearance: 'error' });
      }
      finally {
      }
   }

   // Chat opens in its own browser tab rather than navigating this profile
   // page away, so the viewer can keep the profile open alongside the chat.
   function openChatInNewTab(slug) {
      const url = slug ? `/chat/index?type=user&slug=${slug}` : '/chat/index';
      window.open(url, '_blank', 'noopener,noreferrer');
   }

   async function getBlockUnblock(followerId, isBlockedVal) {
      try {
         const res = await apiHandler(BLOCK_UNBLOCK_FOLLOWER, "POST", {
            follower_id: followerId
         })
         if (res.data?.response?.status === 200) {
            setIsBlocked(isBlockedVal)
         } else {
            addToast(res?.response?.data?.data?.message, { appearance: 'error' });
         }
      } catch (error) {
         //console.error(error);
      }
      finally {
      }
   }

   const formatTime = (timeString) => {
      if (!timeString) return 'N/A';
      const [hours, minutes] = timeString.split(':');
      const hour24 = parseInt(hours, 10);
      const min = parseInt(minutes, 10);

      if (Number.isNaN(hour24) || Number.isNaN(min)) {
         return timeString;
      }

      const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
      const ampm = hour24 >= 12 ? 'PM' : 'AM';
      return `${hour12}:${min.toString().padStart(2, '0')} ${ampm}`;
   }

   const getAgeLabel = (dob) => {
      if (!dob) return 'Age not available';
      const dobMoment = Moment(dob);

      if (!dobMoment.isValid()) {
         return 'Age not available';
      }

      const now = Moment();
      const years = now.diff(dobMoment, 'years');
      const shiftedDob = dobMoment.clone().add(years, 'years');
      const months = now.diff(shiftedDob, 'months');

      if (years < 0 || months < 0) {
         return 'Age not available';
      }

      return `${years} ${years === 1 ? 'year' : 'years'} and ${months} ${months === 1 ? 'month' : 'months'}`;
   }

   const getGenderLabel = (gender) => {
      if (gender === 0 || gender === '0') return 'Male';
      if (gender === 1 || gender === '1') return 'Female';
      return 'Other';
   }

   const isTeacherViewer = isTeacherLoginProfile(currentViewer);
   const isViewedTeacherProfile = isTeacherLoginProfile(profileData);
   const shouldUseSecureStudentProfile = Boolean(
      isTeacherViewer &&
      profileData &&
      profileData?.is_own === 0 &&
      !isViewedTeacherProfile
   );

   if (shouldUseSecureStudentProfile) {
      const infoRows = [
         { label: 'Full Name', value: `${profileData?.first_name || ''} ${profileData?.last_name || ''}`.trim() },
         { label: 'Email', value: profileData?.email },
         { label: 'Mobile', value: profileData?.user_setting?.mobile_no },
         { label: 'Date of Birth', value: profileData?.user_setting?.dob ? Moment(profileData.user_setting.dob).format('MMMM DD, YYYY') : null },
         { label: 'Age', value: getAgeLabel(profileData?.user_setting?.dob) },
         { label: 'Gender', value: getGenderLabel(profileData?.user_setting?.gender) },
         { label: 'Address', value: profileData?.user_setting?.address },
      ].filter((row) => row.value);

      const medicalRows = [
         { label: 'Allergies', value: profileData?.user_setting?.allergies },
         { label: 'Medical Conditions', value: profileData?.user_setting?.medical_conditions },
         { label: "Doctor's Name", value: profileData?.user_setting?.doctors_name },
         { label: "Doctor's Phone", value: profileData?.user_setting?.doctors_phone },
         { label: 'Health Insurance', value: profileData?.user_setting?.health_insurance_provider },
         { label: 'Special Needs / Remarks', value: profileData?.user_setting?.special_needs_or_remarks },
         { label: 'Notes', value: profileData?.user_setting?.notes },
      ].filter((row) => row.value);

      const familyCards = [
         {
            key: 'father',
            title: profileData?.user_setting?.fathers_name,
            subtitle: 'Father',
            detail: profileData?.user_setting?.fathers_occupation,
            iconClass: 'ri-men-line',
            iconColor: '#0d6efd',
            bgColor: '#eff6ff',
         },
         {
            key: 'mother',
            title: profileData?.user_setting?.mothers_name,
            subtitle: 'Mother',
            detail: profileData?.user_setting?.mothers_occupation,
            iconClass: 'ri-women-line',
            iconColor: '#db2777',
            bgColor: '#fdf2f8',
         },
         {
            key: 'guardian',
            title: profileData?.user_setting?.guardian_name,
            subtitle: profileData?.user_setting?.guardian_relationship ? `Guardian · ${profileData.user_setting.guardian_relationship}` : 'Guardian',
            detail: null,
            iconClass: 'ri-shield-user-line',
            iconColor: '#16a34a',
            bgColor: '#f0fdf4',
         },
      ].filter((card) => card.title);

      const documentCards = [
         profileData?.lunch_plan_waiver ? {
            key: 'lunch-plan-waiver',
            title: 'Lunch Plan Waiver',
            iconClass: 'ri-file-text-line',
            iconColor: '#16a34a',
            body: (
               <>
                  {profileData.lunch_plan_waiver.reason && (
                     <p style={{ fontSize: '13px', color: '#374151', marginBottom: '12px' }}>
                        <strong>Reason:</strong> {profileData.lunch_plan_waiver.reason}
                     </p>
                  )}
                  {profileData.lunch_plan_waiver.fillup_date && (
                     <p style={{ fontSize: '13px', color: '#374151', marginBottom: '12px' }}>
                        <strong>Date:</strong> {Moment(profileData.lunch_plan_waiver.fillup_date).format('MMM DD, YYYY')}
                     </p>
                  )}
                  <Row className='g-3 mt-1'>
                     {profileData.lunch_plan_waiver.parents_signature && (
                        <Col md={6}>
                           <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', fontWeight: 600 }}>Parent Signature</div>
                              <img src={profileData.lunch_plan_waiver.parents_signature} alt='parent signature' style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }} />
                           </div>
                        </Col>
                     )}
                     {profileData.lunch_plan_waiver.supervisor_signature && (
                        <Col md={6}>
                           <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', fontWeight: 600 }}>Supervisor Signature</div>
                              <img src={profileData.lunch_plan_waiver.supervisor_signature} alt='supervisor signature' style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }} />
                           </div>
                        </Col>
                     )}
                  </Row>
               </>
            )
         } : null,
         profileData?.allergy_action_plan ? {
            key: 'allergy-action-plan',
            title: 'Allergy & Preference Action Plan',
            iconClass: 'ri-heart-pulse-line',
            iconColor: '#dc2626',
            body: (
               <>
                  <Row className='g-2 mb-3'>
                     {[
                        { label: 'Peanuts', value: profileData.allergy_action_plan.is_peanuts },
                        { label: 'Tree Nuts', value: profileData.allergy_action_plan.is_tree_nuts },
                        { label: 'Milk', value: profileData.allergy_action_plan.is_milk },
                        { label: 'Shellfish', value: profileData.allergy_action_plan.is_shellfish },
                        { label: 'Fish', value: profileData.allergy_action_plan.is_fish },
                        { label: 'Food Additives', value: profileData.allergy_action_plan.is_food_additives },
                        { label: 'All Dairy', value: profileData.allergy_action_plan.all_dairy_products },
                        { label: 'Insect Stings', value: profileData.allergy_action_plan.insect_stings_bites },
                     ].filter((item) => item.value).map((item) => (
                        <Col xs='auto' key={item.label}>
                           <span style={{ background: '#fee2e2', color: '#dc2626', fontSize: '12px', padding: '3px 10px', borderRadius: '20px', fontWeight: 500 }}>{item.label}</span>
                        </Col>
                     ))}
                  </Row>
                  {profileData.allergy_action_plan.symptoms && (
                     <p style={{ fontSize: '13px', color: '#374151', marginBottom: '8px' }}>
                        <strong>Symptoms:</strong> {profileData.allergy_action_plan.symptoms}
                     </p>
                  )}
                  {profileData.allergy_action_plan.emergency_treatment_procedures && (
                     <p style={{ fontSize: '13px', color: '#374151', marginBottom: '8px' }}>
                        <strong>Emergency Treatment:</strong> {profileData.allergy_action_plan.emergency_treatment_procedures}
                     </p>
                  )}
                  {profileData.allergy_action_plan.require_epi_pen === 1 && profileData.allergy_action_plan.location_of_epi_pen && (
                     <p style={{ fontSize: '13px', color: '#374151', marginBottom: '8px' }}>
                        <strong>Epi-Pen Location:</strong> {profileData.allergy_action_plan.location_of_epi_pen}
                     </p>
                  )}
               </>
            )
         } : null,
         profileData?.no_peanut_policy ? {
            key: 'no-peanut-policy',
            title: 'No Peanut Policy',
            iconClass: 'ri-shield-check-line',
            iconColor: '#f59e0b',
            body: (
               <>
                  {profileData.no_peanut_policy.description && (
                     <p style={{ fontSize: '13px', color: '#374151', marginBottom: '12px' }}>
                        <strong>Description:</strong> {profileData.no_peanut_policy.description}
                     </p>
                  )}
                  {profileData.no_peanut_policy.parent_signature && (
                     <Row className='g-3 mt-1'>
                        <Col md={6}>
                           <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '10px', textAlign: 'center' }}>
                              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px', fontWeight: 600 }}>Parent Signature</div>
                              <img src={profileData.no_peanut_policy.parent_signature} alt='parent signature' style={{ maxHeight: '70px', maxWidth: '100%', objectFit: 'contain' }} />
                           </div>
                        </Col>
                     </Row>
                  )}
               </>
            )
         } : null,
      ].filter(Boolean);

      return (
         <Container style={{ marginTop: '12px' }}>
            <Card style={{ border: '1px solid #e8edf3', borderRadius: '12px', overflow: 'hidden' }}>
               <div style={{ padding: '14px 18px', borderBottom: '1px solid #eceff3', background: '#fff' }}>
                  <Row className='g-3 align-items-center'>
                     <Col lg={7}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                           <img
                              src={profileData?.user_setting?.photo || 'https://uzone360live.s3.amazonaws.com/noimage.png'}
                              alt='profile'
                              style={{ width: '52px', height: '52px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #f3f4f6' }}
                           />
                           <div style={{ minWidth: 0, flex: '1 1 240px' }}>
                              <div style={{ fontSize: 'clamp(22px, 4vw, 34px)', lineHeight: 1.1, fontWeight: 700, color: '#1f2937', wordBreak: 'break-word' }}>
                                 {profileData?.first_name} {profileData?.last_name}
                              </div>
                              <div style={{ fontSize: 'clamp(12px, 2.2vw, 16px)', color: '#6b7280', marginTop: '4px', wordBreak: 'break-word' }}>
                                 {getAgeLabel(profileData?.user_setting?.dob)}
                                 {profileData?.user_teachers_and_room?.room?.room_name && (
                                    <>
                                       {' '}|{' '}
                                       <span style={{ color: 'var(--bs-warning)', fontWeight: 600 }}>{profileData.user_teachers_and_room.room.room_name}</span>
                                    </>
                                 )}
                              </div>
                           </div>
                        </div>
                     </Col>
                     <Col lg={5}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', flexWrap: 'wrap' }}>
                           {profileData?.follow_button_show === 1 && (
                              isFollowing == 1 ? (
                                 <Button
                                    variant='outline-primary'
                                    className='rounded'
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={handleUnfollowClick}
                                 >
                                    <i className='ri-user-line me-1'></i>Following
                                 </Button>
                              ) : followRequestStatus === 'pending' ? (
                                 <Button
                                    variant='secondary'
                                    className='rounded'
                                    style={{ whiteSpace: 'nowrap' }}
                                    disabled
                                 >
                                    <i className='ri-user-line me-1'></i>Request Pending
                                 </Button>
                              ) : isFollower == 1 ? (
                                 // Already following you, you just haven't followed
                                 // back - chat is available (see the button below)
                                 // in place of a Follow prompt here.
                                 null
                              ) : (
                                 <Button
                                    variant='primary'
                                    className='rounded'
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={() => getFollowUnfollow(profileData?.id, 1)}
                                 >
                                    <i className='ri-user-add-line me-1'></i>Follow
                                 </Button>
                              )
                           )}
                           {(isFollowing == 1 || isFollower == 1) && (
                              <Button
                                 variant='outline-secondary'
                                 style={{ borderRadius: '20px', whiteSpace: 'nowrap' }}
                                 onClick={() => openChatInNewTab(profileData?.slug)}
                              >
                                 <i className='ri-chat-1-line me-1'></i>Send message
                              </Button>
                           )}
                           {isFollower == 1 && (
                              isBlocked == 0 ? (
                                 <Button
                                    variant='primary'
                                    className='rounded'
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={() => getBlockUnblock(profileData?.id, 1)}
                                 >
                                    <i className='ri-user-add-line me-1'></i>Block
                                 </Button>
                              ) : (
                                 <Button
                                    variant='secondary'
                                    className='rounded'
                                    style={{ whiteSpace: 'nowrap' }}
                                    onClick={() => getBlockUnblock(profileData?.id, 0)}
                                 >
                                    <i className='ri-user-line me-1'></i>Unblock
                                 </Button>
                              )
                           )}
                        </div>
                     </Col>
                  </Row>
               </div>

               <div style={{ padding: '0 16px', borderBottom: '1px solid #eceff3', overflowX: 'auto', background: '#fff' }}>
                  <div style={{ display: 'flex', minWidth: 'max-content' }}>
                     {(() => {
                        const allSecureTabs = ['Timeline', 'About', 'Family', 'Media', 'Documents'];
                        
                        // Function to check if a tab has data
                        const hasTabData = (tab) => {
                           switch (tab) {
                              case 'Timeline':
                                 return true; // Always show Timeline
                              case 'About':
                                 return true; // Always show About
                              case 'Family':
                                 return profileData?.user_setting?.fathers_name || 
                                        profileData?.user_setting?.mothers_name || 
                                        profileData?.user_setting?.guardian_name ||
                                        (profileData?.emergency_contacts && profileData?.emergency_contacts.length > 0);
                              case 'Media':
                                 return profileData?.gallery_images && profileData?.gallery_images.length > 0;
                              case 'Documents':
                                 return profileData?.lunch_plan_waiver || 
                                        profileData?.allergy_action_plan || 
                                        profileData?.no_peanut_policy;
                              default:
                                 return false;
                           }
                        };
                        
                        const visibleTabs = allSecureTabs.filter(tab => hasTabData(tab));
                        
                        return visibleTabs.map((tab) => (
                        <button
                           key={tab}
                           type='button'
                           onClick={() => setSecureActiveTab(tab)}
                           style={{
                              border: 'none',
                              background: 'transparent',
                              borderBottom: secureActiveTab === tab ? '2px solid var(--bs-warning)' : '2px solid transparent',
                              color: secureActiveTab === tab ? 'var(--bs-warning)' : '#6b7280',
                              fontSize: '13px',
                              fontWeight: 600,
                              padding: '10px 12px'
                           }}
                        >
                           {tab}
                        </button>
                     ));
                        })()}
                  </div>
               </div>

               {secureActiveTab === 'About' ? (
                  <div style={{ padding: '16px', background: '#fafbfc' }}>
                     <Row className='g-3'>
                        <Col xl={4} lg={5}>
                           <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                              <Card.Body>
                                 <div style={{ fontWeight: 700, color: '#374151', marginBottom: '10px' }}>Organization</div>
                                 <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '12px' }}>
                                    <div style={{ fontWeight: 700, color: '#1f2937', marginBottom: '4px' }}>
                                       {organizationInfo?.organization_name || 'Organization'}
                                    </div>
                                    {organizationInfo?.logo && (
                                       <img src={organizationInfo.logo} alt='organization logo' style={{ height: '28px', objectFit: 'contain', marginBottom: '8px' }} />
                                    )}
                                    {[
                                       ['Monday', organizationInfo?.monday_start_time, organizationInfo?.monday_end_time],
                                       ['Tuesday', organizationInfo?.tuesday_start_time, organizationInfo?.tuesday_end_time],
                                       ['Wednesday', organizationInfo?.wednesday_start_time, organizationInfo?.wednesday_end_time],
                                       ['Thursday', organizationInfo?.thursday_start_time, organizationInfo?.thursday_end_time],
                                       ['Friday', organizationInfo?.friday_start_time, organizationInfo?.friday_end_time],
                                       ['Saturday', organizationInfo?.saturday_start_time, organizationInfo?.saturday_end_time],
                                       ['Sunday', organizationInfo?.sunday_start_time, organizationInfo?.sunday_end_time],
                                    ].filter(([, start]) => start).map(([day, start, end]) => (
                                       <div key={day} style={{ fontSize: '12px', color: '#6b7280' }}>
                                          {day} {formatTime(start)} - {formatTime(end)}
                                       </div>
                                    ))}
                                 </div>
                              </Card.Body>
                           </Card>
                        </Col>
                        <Col xl={8} lg={7}>
                           <Row className='g-3'>
                              <Col md={6}>
                                 <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                                    <Card.Body>
                                       <h6 style={{ color: '#d97745', fontWeight: 700, marginBottom: '14px', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em' }}>
                                          <i className='ri-user-line me-2'></i>Personal Information
                                       </h6>
                                       {infoRows.map((row) => (
                                          <div key={row.label} style={{ display: 'flex', gap: '8px', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #f3f4f6' }}>
                                             <div style={{ minWidth: '128px', fontSize: '12px', color: '#6b7280', fontWeight: 600 }}>{row.label}</div>
                                             <div style={{ fontSize: '13px', color: '#1f2937', wordBreak: 'break-word' }}>{row.value}</div>
                                          </div>
                                       ))}
                                    </Card.Body>
                                 </Card>
                              </Col>
                              <Col md={6}>
                                 <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                                    <Card.Body>
                                       <h6 style={{ color: '#ef4444', fontWeight: 700, marginBottom: '14px', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em' }}>
                                          <i className='ri-heart-pulse-line me-2'></i>Health & Medical
                                       </h6>
                                       {medicalRows.length > 0 ? medicalRows.map((row) => (
                                          <div key={row.label} style={{ display: 'flex', gap: '8px', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #f3f4f6' }}>
                                             <div style={{ minWidth: '128px', fontSize: '12px', color: '#6b7280', fontWeight: 600 }}>{row.label}</div>
                                             <div style={{ fontSize: '13px', color: '#1f2937', wordBreak: 'break-word' }}>{row.value}</div>
                                          </div>
                                       )) : (
                                          <div style={{ color: '#9ca3af', fontSize: '13px' }}>No health information on file.</div>
                                       )}
                                    </Card.Body>
                                 </Card>
                              </Col>
                              {(profileData?.user_setting?.emergency_contact_name || profileData?.user_setting?.emergency_contact_number) && (
                                 <Col md={12}>
                                    <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                                       <Card.Body>
                                          <h6 style={{ color: '#f59e0b', fontWeight: 700, marginBottom: '14px', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em' }}>
                                             <i className='ri-alarm-warning-line me-2'></i>Primary Emergency Contact
                                          </h6>
                                          <Row className='g-3'>
                                             {[
                                                { label: 'Name', value: profileData?.user_setting?.emergency_contact_name },
                                                { label: 'Relationship', value: profileData?.user_setting?.emergency_relationship },
                                                { label: 'Phone', value: profileData?.user_setting?.emergency_contact_number },
                                                { label: 'Alternate Phone', value: profileData?.user_setting?.emergency_alternate_number },
                                                { label: 'Address', value: profileData?.user_setting?.emergency_address },
                                             ].filter((row) => row.value).map((row) => (
                                                <Col md={4} key={row.label}>
                                                   <div style={{ fontSize: '11px', color: '#6b7280', fontWeight: 600, marginBottom: '2px' }}>{row.label}</div>
                                                   <div style={{ fontSize: '13px', color: '#1f2937' }}>{row.value}</div>
                                                </Col>
                                             ))}
                                          </Row>
                                       </Card.Body>
                                    </Card>
                                 </Col>
                              )}
                           </Row>
                        </Col>
                     </Row>
                  </div>
               ) : secureActiveTab === 'Family' ? (
                  <div style={{ padding: '16px', background: '#fafbfc' }}>
                     <Row className='g-3'>
                        {familyCards.map((card) => (
                           <Col md={4} key={card.key}>
                              <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px', height: '100%' }}>
                                 <Card.Body>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
                                       <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: card.bgColor, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                          <i className={card.iconClass} style={{ color: card.iconColor, fontSize: '20px' }}></i>
                                       </div>
                                       <div>
                                          <div style={{ fontWeight: 700, color: '#1f2937', fontSize: '15px' }}>{card.title}</div>
                                          <div style={{ fontSize: '12px', color: '#6b7280' }}>{card.subtitle}</div>
                                       </div>
                                    </div>
                                    {card.detail && (
                                       <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: '#374151' }}>
                                          <i className='ri-briefcase-line' style={{ color: '#6b7280' }}></i>
                                          {card.detail}
                                       </div>
                                    )}
                                 </Card.Body>
                              </Card>
                           </Col>
                        ))}
                        <Col md={12}>
                           <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                              <Card.Body>
                                 <h6 style={{ color: '#f59e0b', fontWeight: 700, marginBottom: '16px', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.05em' }}>
                                    <i className='ri-alarm-warning-line me-2'></i>Emergency Contacts
                                 </h6>
                                 {profileData?.emergency_contacts?.length > 0 ? (
                                    <Row className='g-3'>
                                       {profileData.emergency_contacts.map((contact, idx) => (
                                          <Col md={4} key={contact.id ?? idx}>
                                             <div style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '14px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                                                   <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: '#fff7ed', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                      <i className='ri-user-line' style={{ color: '#f59e0b', fontSize: '16px' }}></i>
                                                   </div>
                                                   <div>
                                                      <div style={{ fontWeight: 600, color: '#1f2937', fontSize: '14px' }}>{contact.contact_name}</div>
                                                      <div style={{ fontSize: '11px', color: '#6b7280' }}>{contact.relation}</div>
                                                   </div>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
                                                   <i className='ri-phone-line' style={{ color: '#6b7280', fontSize: '13px' }}></i>
                                                   <span style={{ fontSize: '13px', color: '#374151' }}>{contact.phone}</span>
                                                </div>
                                                <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '12px', background: contact.status === 1 ? '#dcfce7' : '#fee2e2', color: contact.status === 1 ? '#16a34a' : '#dc2626', fontWeight: 600 }}>
                                                   {contact.status === 1 ? 'Active' : 'Inactive'}
                                                </span>
                                             </div>
                                          </Col>
                                       ))}
                                    </Row>
                                 ) : (
                                    <div style={{ color: '#9ca3af', fontSize: '13px' }}>No emergency contacts on file.</div>
                                 )}
                              </Card.Body>
                           </Card>
                        </Col>
                     </Row>
                  </div>
               ) : secureActiveTab === 'Media' ? (
                  <div style={{ padding: '16px', background: '#fafbfc' }}>
                     <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                        <Card.Body>
                           <GalleryImageCard userId={profileData?.id} />
                        </Card.Body>
                     </Card>
                  </div>
               ) : secureActiveTab === 'Documents' ? (
                  <div style={{ padding: '16px', background: '#fafbfc' }}>
                     {documentCards.length > 0 ? documentCards.map((card) => (
                        <Card key={card.key} style={{ border: '1px solid #e5e7eb', borderRadius: '8px', marginBottom: '16px' }}>
                           <Card.Body>
                              <h5 style={{ marginBottom: '14px' }}>
                                 <i className={`${card.iconClass} me-2`} style={{ color: card.iconColor }}></i>{card.title}
                              </h5>
                              {card.body}
                           </Card.Body>
                        </Card>
                     )) : (
                        <div style={{ color: '#6b7280', textAlign: 'center', padding: '20px' }}>No documents on file.</div>
                     )}
                  </div>
               ) : (
                  <div style={{ padding: '16px', background: '#fafbfc' }}>
                     <Row className='g-3'>
                        <Col lg={4}>
                           <Card style={{ border: '1px solid #e5e7eb', borderRadius: '8px' }}>
                              <Card.Body>
                                 <div style={{ fontWeight: 700, color: '#374151', marginBottom: '10px' }}>Student Snapshot</div>
                                 <div style={{ fontSize: '13px', color: '#4b5563', marginBottom: '8px' }}>
                                    Room: <strong>{profileData?.user_teachers_and_room?.room?.room_name || 'Not assigned'}</strong>
                                 </div>
                                 <div style={{ fontSize: '13px', color: '#4b5563' }}>
                                    Emergency contacts: <strong>{profileData?.emergency_contacts?.length || 0}</strong>
                                 </div>
                              </Card.Body>
                           </Card>
                           <GalleryImageCard userId={profileData?.id} />
                        </Col>
                        <Col lg={8}>
                           <FeedsList userId={profileData?.id} />
                        </Col>
                     </Row>
                  </div>
               )}
            </Card>
         </Container>
      );
   }


   return (
      <>
         <FsLightbox
            toggler={imageController.toggler}
            sources={[g1, g2, g3, g4, g5, g6, g7, g8, g9]}
            slide={imageController.slide}
         />
         <Container style={{ marginTop: "12px" }}>
            <Row>
               <Col sm={12}>
                  <Card>
                     <Card.Body className=" profile-page p-0">
                        <div className="profile-header profile-info">
                           <div className="cover-container">
                              <img loading="lazy" src={img1} alt="profile-bg" className="rounded img-fluid" />
                              {/* <ul className="header-nav d-flex flex-wrap justify-end p-0 m-0">
                                 <li>
                                    <Link to="#" className="material-symbols-outlined">
                                       edit
                                    </Link>
                                 </li>
                                 <li>
                                    <Link to="#" className="material-symbols-outlined">
                                       settings
                                    </Link>
                                 </li>
                              </ul> */}
                           </div>
                           <div className="user-detail text-center mb-3">
                              <div className="profile-img">
                                 <img style={{ height: 130, width: 130 }} loading="lazy" src={profileData?.user_setting?.photo ?
                                    profileData?.user_setting?.photo :
                                    "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="profile-img" className="avatar-130 img-fluid" />
                              </div>
                              <div className="profile-detail">
                                 <h3>{profileData?.first_name && (profileData?.first_name + " " + profileData?.last_name)}</h3>
                              </div>
                           </div>
                           <div className="profile-info p-4 d-flex align-items-center justify-content-between position-relative">
                              <div className="social-links">
                                 <ul className="social-data-block d-flex align-items-center justify-content-between list-inline p-0 m-0">
                                    <li className="text-center pe-3">
                                       <h6>Posts</h6>
                                       <p className="mb-0">{profileData?.post_count}</p>
                                    </li>
                                    <li className="text-center pe-3">
                                       <h6>Followers</h6>
                                       <p className="mb-0">{profileData?.follower_count}</p>
                                    </li>
                                    <li className="text-center pe-3">
                                       <h6>Following</h6>
                                       <p className="mb-0">{profileData?.following_count}</p>
                                    </li>
                                 </ul>
                                 {/* <ul className="social-data-block d-flex align-items-center justify-content-between list-inline p-0 m-0">
                                    <li className="text-center pe-3">
                                       <Link to="#"><img loading="lazy" src={icon8} className="img-fluid rounded" alt="facebook"/></Link>
                                    </li>
                                    <li className="text-center pe-3">
                                       <Link to="#"><img loading="lazy" src={icon9} className="img-fluid rounded" alt="Twitter"/></Link>
                                    </li>
                                    <li className="text-center pe-3">
                                       <Link to="#"><img loading="lazy" src={icon10} className="img-fluid rounded" alt="Instagram"/></Link>
                                    </li>
                                    <li className="text-center pe-3">
                                       <Link to="#"><img loading="lazy" src={icon11} className="img-fluid rounded" alt="Google plus"/></Link>
                                    </li>
                                    <li className="text-center pe-3">
                                       <Link to="#"><img loading="lazy" src={icon12} className="img-fluid rounded" alt="You tube"/></Link>
                                    </li>
                                    <li className="text-center pe-3">
                                       <Link to="#"><img loading="lazy" src={icon13} className="img-fluid rounded" alt="linkedin"/></Link>
                                    </li>
                                 </ul> */}
                              </div>
                              <div className="social-info">
                                 {
                                    profileData?.is_own === 0 ?
                                       <div>
                                          {
                                             profileData?.follow_button_show === 1 && (
                                                isFollowing == 1 ?
                                                   <Link to="#" className="me-3 btn btn-outline-primary rounded"
                                                      onClick={(e) => {
                                                         e.preventDefault();
                                                         handleUnfollowClick()
                                                      }}><i className="ri-user-line me-1"></i>Following</Link> :
                                                   followRequestStatus === 'pending' ?
                                                      <Link to="#" className="me-3 btn btn-secondary rounded disabled"
                                                         style={{ pointerEvents: 'none', cursor: 'default' }}
                                                         onClick={(e) => e.preventDefault()}
                                                      ><i className="ri-user-line me-1"></i>Request Pending</Link> :
                                                      isFollower == 1 ?
                                                         // Already following you, you just haven't followed
                                                         // back - chat is available below in place of a
                                                         // Follow prompt here.
                                                         null :
                                                         <Link to="#" className="me-3 btn btn-primary rounded"
                                                            onClick={(e) => {
                                                               e.preventDefault();
                                                               console.log('Sending follow request to user:', profileData?.id)
                                                               getFollowUnfollow(profileData?.id, 1)
                                                            }}><i className="ri-user-add-line me-1"></i>Follow</Link>
                                             )
                                          }
                                          {
                                             (isFollowing == 1 || isFollower == 1) &&
                                                <Link to="#" className="me-3 btn btn-outline-secondary rounded"
                                                   onClick={(e) => {
                                                      e.preventDefault();
                                                      openChatInNewTab(profileData?.slug)
                                                   }}><i className="ri-chat-1-line me-1"></i>Send message</Link>
                                          }
                                          {
                                             isFollower == 1 ?
                                                <>
                                                   {
                                                      isBlocked == 0 ?
                                                         <Link to="#" className="me-3 btn btn-primary rounded"
                                                            onClick={() => {
                                                               getBlockUnblock(profileData?.id, 1)
                                                            }}><i className="ri-user-add-line me-1"></i>Block</Link> :
                                                         <Link to="#" className="me-3 btn btn-secondary rounded"
                                                            onClick={() => {
                                                               getBlockUnblock(profileData?.id, 0)
                                                            }}><i className="ri-user-line me-1"></i>Unblock</Link>
                                                   }
                                                </> : null
                                          }
                                       </div> : null
                                 }

                              </div>
                           </div>
                        </div>
                     </Card.Body>
                  </Card>
               </Col>
               <Row>
                  <Col lg={4}>
                     {/*<Card>
                        <div className="card-header d-flex justify-content-between">
                           <div className="header-title">
                              <h4 className="card-title">About</h4>
                           </div>
                        </div>
                        <Card.Body>
                           <ul className="list-inline p-0 m-0">
                              <li className="mb-2 d-flex align-items-center">
                                 <span className="material-symbols-outlined md-18">
                                    email
                                 </span>
                                 <p className="mb-0 ms-2">{profileData?.email}</p>
                              </li>
                              <li className="mb-2 d-flex align-items-center">
                                 <span className="material-symbols-outlined md-18">
                                    phone
                                 </span>
                                 <p className="mb-0 ms-2">{profileData?.user_setting?.mobile_no}</p>
                              </li>
                              <li className="mb-2 d-flex align-items-center">
                                 <span className="material-symbols-outlined md-18">
                                    calendar_month
                                 </span>
                                 <p className="mb-0 ms-2">{Moment(profileData?.user_setting?.dob).format('YYYY')}</p>
                              </li>
                              <li className="d-flex align-items-center">
                                 <span className="material-symbols-outlined md-18">
                                    assignment_ind
                                 </span>
                                 <p className="mb-0 ms-2">{profileData?.user_setting?.gender == 0 ? "Male" :
                                    profileData?.user_setting?.gender == 1 ? "Female" : "Other"}</p>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card> */}
                     
                     {/* <Card>
                        <div className="card-header d-flex justify-content-between">
                           <div className="header-timport FsLightbox from 'fslightbox-react';itle">
                              <h4 className="card-title">Photos</h4>
                           </div>
                           <div className="card-header-toolbar d-flex align-items-center">
                              <p className="m-0"><Link to="#">Add Photo </Link></p>
                           </div>
                        </div>
                        <Card.Body>
                           <ul className="profile-img-gallary p-0 m-0 list-unstyled">
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(1)} src={g1} alt="gallary" className="img-fluid" /></Link></li>
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(2)} src={g2} alt="gallary" className="img-fluid" /></Link></li>
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(3)} src={g3} alt="gallary" className="img-fluid" /></Link></li>
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(4)} src={g4} alt="gallary" className="img-fluid" /></Link></li>
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(5)} src={g5} alt="gallary" className="img-fluid" /></Link></li>
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(6)} src={g6} alt="gallary" className="img-fluid" /></Link></li>
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(7)} src={g7} alt="gallary" className="img-fluid" /></Link></li>
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(8)} src={g8} alt="gallary" className="img-fluid" /></Link></li>
                              <li><Link to="#"><img loading="lazy" onClick={() => imageOnSlide(9)} src={g9} alt="gallary" className="img-fluid" /></Link></li>
                           </ul>
                        </Card.Body>
                     </Card> */}
                     {
                        profileData ?
                           <GalleryImageCard userId={profileData?.id} /> : null
                     }
                     {/* <Card>
                        <div className="card-header d-flex justify-content-between">
                           <div className="header-title">
                              <h4 className="card-title">Friends</h4>
                           </div>
                           <div className="card-header-toolbar d-flex align-items-center">
                              <p className="m-0"><Link to="#">Add New </Link></p>
                           </div>
                        </div>
                        <Card.Body>
                           <ul className="profile-img-gallary p-0 m-0 list-unstyled">
                              <li>
                                 <Link to="#">
                                    <img loading="lazy" src={user05} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Anna Rexia</h6>
                              </li>
                              <li>
                                 <Link to="#"><img loading="lazy" src={user06} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Tara Zona</h6>
                              </li>
                              <li>
                                 <Link to="#"><img loading="lazy" src={user07} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Polly Tech</h6>
                              </li>
                              <li>
                                 <Link to="#"><img loading="lazy" src={user08} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Bill Emia</h6>
                              </li>
                              <li>
                                 <Link to="#"><img loading="lazy" src={user09} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Moe Fugga</h6>
                              </li>
                              <li>
                                 <Link to="#"><img loading="lazy" src={user10} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Hal Appeno </h6>
                              </li>
                              <li>
                                 <Link to="#"><img loading="lazy" src={user07} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Zack Lee</h6>
                              </li>
                              <li>
                                 <Link to="#"><img loading="lazy" src={user06} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Terry Aki</h6>
                              </li>
                              <li>
                                 <Link to="#"><img loading="lazy" src={user05} alt="gallary" className="img-fluid" /></Link>
                                 <h6 className="mt-2 text-center">Greta Life</h6>
                              </li>
                           </ul>
                        </Card.Body>
                     </Card> */}
                  </Col>
                  <Col lg={8}>
                     {
                        profileData ?
                           <FeedsList userId={profileData?.id} /> : null
                     }

                     {/* <Card id="post-modal-data">
                        <div className="card-header d-flex justify-content-between">
                           <div className="header-title">
                              <h4 className="card-title">Create Post</h4>
                           </div>
                        </div>
                        <Card.Body data-toggle="modal" data-target="#post-modal">
                           <div className="d-flex align-items-center">
                              <div className="user-img">
                                 <img loading="lazy" src={user1} alt="userimg" className="avatar-60 rounded-circle img-fluid" />
                              </div>
                              <form className="post-text ms-3 w-100" >
                                 <input type="text" className="form-control rounded" placeholder="Write something here..." style={{ border: "none" }} onClick={handleShow} />
                              </form>
                           </div>
                           <hr />
                           <ul className=" post-opt-block d-flex list-inline m-0 p-0 flex-wrap">
                              <li className="bg-soft-primary rounded p-2 pointer d-flex align-items-center me-3 mb-md-0 mb-2"><img loading="lazy" src={small07} alt="icon" className="img-fluid me-2" /> Photo/Video</li>
                              <li className="bg-soft-primary rounded p-2 pointer d-flex align-items-center me-3 mb-md-0 mb-2"><img loading="lazy" src={small08} alt="icon" className="img-fluid me-2" /> Tag Friend</li>
                              <li className="bg-soft-primary rounded p-2 pointer d-flex align-items-center me-3 mb-md-0 mb-2"><img loading="lazy" src={small09} alt="icon" className="img-fluid me-2" /> Feeling/Activity</li>
                              <li className="bg-soft-primary rounded p-2 pointer text-center">
                                 <div className="card-header-toolbar d-flex align-items-center">
                                    <Dropdown>
                                       <Dropdown.Toggle as={CustomToggle} id="post-option"  >
                                          <span className="material-symbols-outlined">
                                             more_horiz
                                          </span>
                                       </Dropdown.Toggle>
                                       <Dropdown.Menu className=" dropdown-menu-right" aria-labelledby="post-option" >
                                          <Dropdown.Item onClick={handleShow} href="#" >Check in</Dropdown.Item>
                                          <Dropdown.Item onClick={handleShow} href="#" >Live Video</Dropdown.Item>
                                          <Dropdown.Item onClick={handleShow} href="#" >Gif</Dropdown.Item>
                                          <Dropdown.Item onClick={handleShow} href="#" >Watch Party</Dropdown.Item>
                                          <Dropdown.Item onClick={handleShow} href="#" >Play with Friend</Dropdown.Item>
                                       </Dropdown.Menu>
                                    </Dropdown>
                                 </div>
                              </li>
                           </ul>
                        </Card.Body>
                        <Modal show={show} onHide={handleClose} size="lg">
                           <Modal.Header className="d-flex justify-content-between">
                              <h5 className="modal-title" id="post-modalLabel">Create Post</h5>
                              <button type="button" className="btn btn-secondary lh-1" onClick={handleClose} ><span className="material-symbols-outlined">close</span></button>
                           </Modal.Header>
                           <Modal.Body>
                              <div className="d-flex align-items-center">
                                 <div className="user-img">
                                    <img loading="lazy" src={img5} alt="userimg" className="avatar-60 rounded-circle img-fluid" />
                                 </div>
                                 <form className="post-text ms-3 w-100" action="">
                                    <input type="text" className="form-control rounded" placeholder="Write something here..." style={{ border: "none" }} />
                                 </form>
                              </div>
                              <hr />
                              <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0">
                                 <li className="col-md-6 mb-3">
                                    <div className="bg-soft-primary rounded p-2 pointer me-3"><Link to="#"></Link><img loading="lazy" src={small1} alt="icon" className="img-fluid" /> Photo/Video</div>
                                 </li>
                                 <li className="col-md-6 mb-3">
                                    <div className="bg-soft-primary rounded p-2 pointer me-3"><Link to="#"></Link><img loading="lazy" src={small2} alt="icon" className="img-fluid" /> Tag Friend</div>
                                 </li>
                                 <li className="col-md-6 mb-3">
                                    <div className="bg-soft-primary rounded p-2 pointer me-3"><Link to="#"></Link><img loading="lazy" src={small3} alt="icon" className="img-fluid" /> Feeling/Activity</div>
                                 </li>
                                 <li className="col-md-6 mb-3">
                                    <div className="bg-soft-primary rounded p-2 pointer me-3"><Link to="#"></Link><img loading="lazy" src={small4} alt="icon" className="img-fluid" /> Check in</div>
                                 </li>
                                 <li className="col-md-6 mb-3">
                                    <div className="bg-soft-primary rounded p-2 pointer me-3"><Link to="#"></Link><img loading="lazy" src={small5} alt="icon" className="img-fluid" /> Live Video</div>
                                 </li>
                                 <li className="col-md-6 mb-3">
                                    <div className="bg-soft-primary rounded p-2 pointer me-3"><Link to="#"></Link><img loading="lazy" src={small6} alt="icon" className="img-fluid" /> Gif</div>
                                 </li>
                                 <li className="col-md-6 mb-3">
                                    <div className="bg-soft-primary rounded p-2 pointer me-3"><Link to="#"></Link><img loading="lazy" src={small7} alt="icon" className="img-fluid" /> Watch Party</div>
                                 </li>
                                 <li className="col-md-6 mb-3">
                                    <div className="bg-soft-primary rounded p-2 pointer me-3"><Link to="#"></Link><img loading="lazy" src={small8} alt="icon" className="img-fluid" /> Play with Friends</div>
                                 </li>
                              </ul>
                              <hr />
                              <div className="other-option">
                                 <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                       <div className="user-img me-3">
                                          <img loading="lazy" src={user9} alt="userimg" className="avatar-60 rounded-circle img-fluid" />
                                       </div>
                                       <h6>Your Story</h6>
                                    </div>
                                    <div className="card-post-toolbar">
                                       <Dropdown>
                                          <Dropdown.Toggle className="dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" role="button">
                                             <span className="btn btn-primary">Friend</span>
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu clemassName="dropdown-menu m-0 p-0">
                                             <Dropdown.Item className="dropdown-item p-3" href="#">
                                                <div className="d-flex align-items-top">
                                                   <i className="ri-save-line h4"></i>
                                                   <div className="data ms-2">
                                                      <h6>Public</h6>
                                                      <p className="mb-0">Anyone on or off Facebook</p>
                                                   </div>
                                                </div>
                                             </Dropdown.Item>
                                             <Dropdown.Item className="dropdown-item p-3" href="#">
                                                <div className="d-flex align-items-top">
                                                   <i className="ri-close-circle-line h4"></i>
                                                   <div className="data ms-2">
                                                      <h6>Friends</h6>
                                                      <p className="mb-0">Your Friend on facebook</p>
                                                   </div>
                                                </div>
                                             </Dropdown.Item>
                                             <Dropdown.Item className="dropdown-item p-3" href="#">
                                                <div className="d-flex align-items-top">
                                                   <i className="ri-user-unfollow-line h4"></i>
                                                   <div className="data ms-2">
                                                      <h6>Friends except</h6>
                                                      <p className="mb-0">Don't show to some friends</p>
                                                   </div>
                                                </div>
                                             </Dropdown.Item>
                                             <Dropdown.Item className="dropdown-item p-3" href="#">
                                                <div className="d-flex align-items-top">
                                                   <i className="ri-notification-line h4"></i>
                                                   <div className="data ms-2">
                                                      <h6>Only Me</h6>
                                                      <p className="mb-0">Only me</p>
                                                   </div>
                                                </div>
                                             </Dropdown.Item>
                                          </Dropdown.Menu>
                                       </Dropdown>
                                    </div>
                                 </div>
                              </div>
                              <Button variant="primary" className="d-block w-100 mt-3">Post</Button>
                           </Modal.Body>
                        </Modal>
                     </Card> */}
                     {/* <Card>
                        <Card.Body>
                           <div className="post-item">
                              <div className="user-post-data p-3">
                                 <div className="d-flex justify-content-between">
                                    <div className="me-3">
                                       <img loading="lazy" className="rounded-circle  avatar-60" src={user05} alt="" />
                                    </div>
                                    <div className="w-100">
                                       <div className="d-flex justify-content-between flex-wrap">
                                          <div>
                                             <h5 className="mb-0 d-inline-block"><Link to="#">Anna Sthesia</Link></h5>

                                             <p className="mb-0">8 hour ago</p>
                                          </div>
                                          <div className="card-post-toolbar">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle}>
                                                   <i className="ri-more-fill"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className=" m-0 p-0">
                                                   <Dropdown.Item className="p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-save-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Save Post</h6>
                                                            <p className="mb-0">Add this to your saved items</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className=" p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-pencil-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Edit Post</h6>
                                                            <p className="mb-0">Update your post and saved items</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className="p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-close-circle-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Hide From Timeline</h6>
                                                            <p className="mb-0">See fewer posts like this.</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className=" p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-delete-bin-7-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Delete</h6>
                                                            <p className="mb-0">Remove thids Post on Timeline</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className=" p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-notification-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Notifications</h6>
                                                            <p className="mb-0">Turn on notifications for this post</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="user-post">
                                 <Link to="#"><img loading="lazy" src={img59} alt="post" className="img-fluid w-100" /></Link>
                              </div>
                              <div className="comment-area mt-3">
                                 <div className="d-flex justify-content-between align-items-center">
                                    <div className="like-block position-relative d-flex align-items-center">
                                       <div className="d-flex align-items-center">
                                          <div className="like-data">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle} role="button">
                                                   <img loading="lazy" src={icon1} className="img-fluid" alt="" />
                                                </Dropdown.Toggle>
                                                <div className="dropdown-menu">
                                                   <Link className="ml-2 mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Like"><img loading="lazy" src={icon1} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Love"><img loading="lazy" src={icon2} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Happy"><img loading="lazy" src={icon3} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="HaHa"><img loading="lazy" src={icon4} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Think"><img loading="lazy" src={icon5} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Sade"><img loading="lazy" src={icon6} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Lovely"><img loading="lazy" src={icon7} className="img-fluid me-2" alt="" /></Link>
                                                </div>
                                             </Dropdown>
                                          </div>
                                          <div className="total-like-block ms-2 me-3">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                   140 Likes
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                   <Dropdown.Item to="#">Max Emum</Dropdown.Item>
                                                   <Dropdown.Item to="#">Bill Yerds</Dropdown.Item>
                                                   <Dropdown.Item to="#">Hap E. Birthday</Dropdown.Item>
                                                   <Dropdown.Item to="#">Tara Misu</Dropdown.Item>
                                                   <Dropdown.Item to="#">Midge Itz</Dropdown.Item>
                                                   <Dropdown.Item to="#">Sal Vidge</Dropdown.Item>
                                                   <Dropdown.Item to="#">Other</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                       <div className="total-comment-block">
                                          <Dropdown>
                                             <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                20 Comment
                                             </Dropdown.Toggle>
                                             <Dropdown.Menu>
                                                <Dropdown.Item to="#">Max Emum</Dropdown.Item>
                                                <Dropdown.Item to="#">Bill Yerds</Dropdown.Item>
                                                <Dropdown.Item to="#">Hap E. Birthday</Dropdown.Item>
                                                <Dropdown.Item to="#">Tara Misu</Dropdown.Item>
                                                <Dropdown.Item to="#">Midge Itz</Dropdown.Item>
                                                <Dropdown.Item to="#">Sal Vidge</Dropdown.Item>
                                                <Dropdown.Item to="#">Other</Dropdown.Item>
                                             </Dropdown.Menu>
                                          </Dropdown>
                                       </div>
                                    </div>
                                    <ShareOffcanvas />
                                 </div>
                                 <hr />
                                 <ul className="post-comments p-0 m-0">
                                    <li className="mb-2">
                                       <div className="d-flex flex-wrap">
                                          <div className="user-img">
                                             <img loading="lazy" src={user09} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                          </div>
                                          <div className="comment-data-block ms-3">
                                             <h6>Moe Fugga</h6>
                                             <p className="mb-0">Lorem ipsum dolor sit amet</p>
                                             <div className="d-flex flex-wrap align-items-center comment-activity">
                                                <Link to="#">like</Link>
                                                <Link to="#">reply</Link>
                                                <Link to="#">translate</Link>
                                                <span> 3 min </span>
                                             </div>
                                          </div>
                                       </div>
                                    </li>
                                    <li>
                                       <div className="d-flex flex-wrap">
                                          <div className="user-img">
                                             <img loading="lazy" src={user08} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                          </div>
                                          <div className="comment-data-block ms-3">
                                             <h6>Bill Emia</h6>
                                             <p className="mb-0">Lorem ipsum dolor sit amet</p>
                                             <div className="d-flex flex-wrap align-items-center comment-activity">
                                                <Link to="#">like</Link>
                                                <Link to="#">reply</Link>
                                                <Link to="#">translate</Link>
                                                <span> 5 min </span>
                                             </div>
                                          </div>
                                       </div>
                                    </li>
                                 </ul>
                                 <form className="comment-text d-flex align-items-center mt-3" >
                                    <input type="text" className="form-control rounded" />
                                    <div className="comment-attagement d-flex">
                                       <Link to="#" className="material-symbols-outlined me-3 link">insert_link</Link>
                                       <Link to="#" className="material-symbols-outlined  me-3">sentiment_satisfied</Link>
                                       <Link to="#" className="material-symbols-outlined  me-3">photo_camera</Link>
                                    </div>
                                 </form>
                              </div>
                           </div>
                           <div className="post-item">
                              <div className="user-post-data p-3">
                                 <div className="d-flex justify-content-between">
                                    <div className="me-3">
                                       <img loading="lazy" className="rounded-circle  avatar-60" src={user1} alt="" />
                                    </div>
                                    <div className="w-100">
                                       <div className="d-flex justify-content-between flex-wrap">
                                          <div>
                                             <h5 className="mb-0 d-inline-block"><Link to="#">Bni Cyst</Link></h5>
                                             <p className="ms-1 mb-0 d-inline-block">Update his Status</p>
                                             <p className="mb-0">7 hour ago</p>
                                          </div>
                                          <div className="card-post-toolbar">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle}>
                                                   <i className="ri-more-fill"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className=" m-0 p-0">
                                                   <Dropdown.Item className=" p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-save-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Save Post</h6>
                                                            <p className="mb-0">Add this to your saved items</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className="p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-pencil-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Edit Post</h6>
                                                            <p className="mb-0">Update your post and saved items</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className=" p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-close-circle-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Hide From Timeline</h6>
                                                            <p className="mb-0">See fewer posts like this.</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className="p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-delete-bin-7-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Delete</h6>
                                                            <p className="mb-0">Remove thids Post on Timeline</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className=" p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-notification-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Notifications</h6>
                                                            <p className="mb-0">Turn on notifications for this post</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="user-post">
                                 <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,</p>
                              </div>
                              <div className="comment-area mt-3">
                                 <div className="d-flex justify-content-between align-items-center">
                                    <div className="like-block position-relative d-flex align-items-center">
                                       <div className="d-flex align-items-center">
                                          <div className="like-data">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle} aria-haspopup="true" aria-expanded="false" role="button">
                                                   <img loading="lazy" src={icon1} className="img-fluid" alt="" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                   <Link className="ms-2 me-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Like"><img loading="lazy" src={icon1} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Love"><img loading="lazy" src={icon2} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Happy"><img loading="lazy" src={icon3} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="HaHa"><img loading="lazy" src={icon4} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Think"><img loading="lazy" src={icon5} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Sade"><img loading="lazy" src={icon6} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Lovely"><img loading="lazy" src={icon7} className="img-fluid me-2" alt="" /></Link>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                          <div className="total-like-block ms-2 me-3">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                   140 Likes
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                   <Dropdown.Item to="#">Max Emum</Dropdown.Item>
                                                   <Dropdown.Item to="#">Bill Yerds</Dropdown.Item>
                                                   <Dropdown.Item to="#">Hap E. Birthday</Dropdown.Item>
                                                   <Dropdown.Item to="#">Tara Misu</Dropdown.Item>
                                                   <Dropdown.Item to="#">Midge Itz</Dropdown.Item>
                                                   <Dropdown.Item to="#">Sal Vidge</Dropdown.Item>
                                                   <Dropdown.Item to="#">Other</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                       <div className="total-comment-block">
                                          <Dropdown>
                                             <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                20 Comment
                                             </Dropdown.Toggle>
                                             <Dropdown.Menu>
                                                <Dropdown.Item to="#">Max Emum</Dropdown.Item>
                                                <Dropdown.Item to="#">Bill Yerds</Dropdown.Item>
                                                <Dropdown.Item to="#">Hap E. Birthday</Dropdown.Item>
                                                <Dropdown.Item to="#">Tara Misu</Dropdown.Item>
                                                <Dropdown.Item to="#">Midge Itz</Dropdown.Item>
                                                <Dropdown.Item to="#">Sal Vidge</Dropdown.Item>
                                                <Dropdown.Item to="#">Other</Dropdown.Item>
                                             </Dropdown.Menu>
                                          </Dropdown>
                                       </div>
                                    </div>
                                    <ShareOffcanvas />
                                 </div>
                                 <hr />
                                 <ul className="post-comments p-0 m-0">
                                    <li className="mb-2">
                                       <div className="d-flex flex-wrap">
                                          <div className="user-img">
                                             <img loading="lazy" src={user02} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                          </div>
                                          <div className="comment-data-block ms-3">
                                             <h6>Monty Carlo</h6>
                                             <p className="mb-0">Lorem ipsum dolor sit amet</p>
                                             <div className="d-flex flex-wrap align-items-center comment-activity">
                                                <Link to="#">like</Link>
                                                <Link to="#">reply</Link>
                                                <Link to="#">translate</Link>
                                                <span> 5 min </span>
                                             </div>
                                          </div>
                                       </div>
                                    </li>
                                    <li>
                                       <div className="d-flex flex-wrap">
                                          <div className="user-img">
                                             <img loading="lazy" src={user03} alt="user" className="avatar-35 rounded-circle img-fluid" />
                                          </div>
                                          <div className="comment-data-block ms-3">
                                             <h6>Paul Molive</h6>
                                             <p className="mb-0">Lorem ipsum dolor sit amet</p>
                                             <div className="d-flex flex-wrap align-items-center comment-activity">
                                                <Link to="#">like</Link>
                                                <Link to="#">reply</Link>
                                                <Link to="#">translate</Link>
                                                <span> 5 min </span>
                                             </div>
                                          </div>
                                       </div>
                                    </li>
                                 </ul>
                                 <form className="comment-text d-flex align-items-center mt-3" >
                                    <input type="text" className="form-control rounded" />
                                    <div className="comment-attagement d-flex">
                                       <Link to="#" className="material-symbols-outlined me-3 link">insert_link</Link>
                                       <Link to="#" className="material-symbols-outlined  me-3">sentiment_satisfied</Link>
                                       <Link to="#" className="material-symbols-outlined  me-3">photo_camera</Link>
                                    </div>
                                 </form>
                              </div>
                           </div>
                           <div className="post-item">
                              <div className="user-post-data p-3">
                                 <div className="d-flex justify-content-between">
                                    <div className="me-3">
                                       <img loading="lazy" className="rounded-circle  avatar-60" src={user05} alt="" />
                                    </div>
                                    <div className="w-100">
                                       <div className="d-flex justify-content-between flex-wrap">
                                          <div>
                                             <h5 className="mb-0 d-inline-block"><Link to="#">Bni Cyst</Link></h5>
                                             <p className="ms-1 mb-0 d-inline-block">Update his Status</p>
                                             <p className="mb-0">7 hour ago</p>
                                          </div>
                                          <div className="card-post-toolbar">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle} >
                                                   <i className="ri-more-fill"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="m-0 p-0">
                                                   <Dropdown.Item className=" p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-save-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Save Post</h6>
                                                            <p className="mb-0">Add this to your saved items</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className="p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-pencil-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Edit Post</h6>
                                                            <p className="mb-0">Update your post and saved items</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Dropdown.Item className="p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-close-circle-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Hide From Timeline</h6>
                                                            <p className="mb-0">See fewer posts like this.</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                   <Link className="dropdown-item p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-delete-bin-7-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Delete</h6>
                                                            <p className="mb-0">Remove thids Post on Timeline</p>
                                                         </div>
                                                      </div>
                                                   </Link>
                                                   <Dropdown.Item className="p-3" to="#">
                                                      <div className="d-flex align-items-top">
                                                         <i className="ri-notification-line h4"></i>
                                                         <div className="data ms-2">
                                                            <h6>Notifications</h6>
                                                            <p className="mb-0">Turn on notifications for this post</p>
                                                         </div>
                                                      </div>
                                                   </Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="user-post">
                                 <div className=" d-grid grid-rows-2 grid-flow-col gap-3">
                                    <div className="row-span-2 row-span-md-1">
                                       <Link to="#">
                                          <img loading="lazy" src={img56} alt="post" className="img-fluid w-100" />
                                       </Link>
                                    </div>
                                    <div className="row-span-1">
                                       <Link to="#">
                                          <img loading="lazy" src={img57} alt="post" className="img-fluid w-100" />
                                       </Link>
                                    </div>
                                    <div className="row-span-1 ">
                                       <Link to="#">
                                          <img loading="lazy" src={img58} alt="post" className="img-fluid w-100" />
                                       </Link>
                                    </div>
                                 </div>
                              </div>
                              <div className="comment-area mt-3">
                                 <div className="d-flex justify-content-between align-items-center">
                                    <div className="like-block position-relative d-flex align-items-center">
                                       <div className="d-flex align-items-center">
                                          <div className="like-data">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle} role="button">
                                                   <img loading="lazy" src={icon1} className="img-fluid" alt="" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                   <Link className="ml-2 mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Like"><img loading="lazy" src={icon1} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Love"><img loading="lazy" src={icon2} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Happy"><img loading="lazy" src={icon3} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="HaHa"><img loading="lazy" src={icon4} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Think"><img loading="lazy" src={icon5} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Sade"><img loading="lazy" src={icon6} className="img-fluid me-2" alt="" /></Link>
                                                   <Link className="mr-2" to="#" data-toggle="tooltip" data-placement="top" title="" data-original-title="Lovely"><img loading="lazy" src={icon7} className="img-fluid me-2" alt="" /></Link>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                          <div className="total-like-block ms-2 me-3">
                                             <Dropdown>
                                                <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                   140 Likes
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                   <Dropdown.Item to="#">Max Emum</Dropdown.Item>
                                                   <Dropdown.Item to="#">Bill Yerds</Dropdown.Item>
                                                   <Dropdown.Item to="#">Hap E. Birthday</Dropdown.Item>
                                                   <Dropdown.Item to="#">Tara Misu</Dropdown.Item>
                                                   <Dropdown.Item to="#">Midge Itz</Dropdown.Item>
                                                   <Dropdown.Item to="#">Sal Vidge</Dropdown.Item>
                                                   <Dropdown.Item to="#">Other</Dropdown.Item>
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </div>
                                       </div>
                                       <div className="total-comment-block">
                                          <Dropdown>
                                             <Dropdown.Toggle as={CustomToggle} id="post-option" >
                                                20 Comment
                                             </Dropdown.Toggle>
                                             <Dropdown.Menu>
                                                <Dropdown.Item to="#">Max Emum</Dropdown.Item>
                                                <Dropdown.Item to="#">Bill Yerds</Dropdown.Item>
                                                <Dropdown.Item to="#">Hap E. Birthday</Dropdown.Item>
                                                <Dropdown.Item to="#">Tara Misu</Dropdown.Item>
                                                <Dropdown.Item to="#">Midge Itz</Dropdown.Item>
                                                <Dropdown.Item to="#">Sal Vidge</Dropdown.Item>
                                                <Dropdown.Item to="#">Other</Dropdown.Item>
                                             </Dropdown.Menu>
                                          </Dropdown>
                                       </div>
                                    </div>
                                    <ShareOffcanvas />
                                 </div>
                                 <hr />
                                 <ul className="post-comments p-0 m-0">
                                    <li className="mb-2">
                                       <div className="d-flex flex-wrap">
                                          <div className="user-img">
                                             <img loading="lazy" src={user02} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                          </div>
                                          <div className="comment-data-block ms-3">
                                             <h6>Monty Carlo</h6>
                                             <p className="mb-0">Lorem ipsum dolor sit amet</p>
                                             <div className="d-flex flex-wrap align-items-center comment-activity">
                                                <Link to="#">like</Link>
                                                <Link to="#">reply</Link>
                                                <Link to="#">translate</Link>
                                                <span> 5 min </span>
                                             </div>
                                          </div>
                                       </div>
                                    </li>
                                    <li>
                                       <div className="d-flex flex-wrap">
                                          <div className="user-img">
                                             <img loading="lazy" src={user03} alt="userimg" className="avatar-35 rounded-circle img-fluid" />
                                          </div>
                                          <div className="comment-data-block ms-3">
                                             <h6>Paul Molive</h6>
                                             <p className="mb-0">Lorem ipsum dolor sit amet</p>
                                             <div className="d-flex flex-wrap align-items-center comment-activity">
                                                <Link to="#">like</Link>
                                                <Link to="#">reply</Link>
                                                <Link to="#">translate</Link>
                                                <span> 5 min </span>
                                             </div>
                                          </div>
                                       </div>
                                    </li>
                                 </ul>
                                 <form className="comment-text d-flex align-items-center mt-3" >
                                    <input type="text" className="form-control rounded" />
                                    <div className="comment-attagement d-flex">
                                       <Link to="#" className="material-symbols-outlined me-3 link">insert_link</Link>
                                       <Link to="#" className="material-symbols-outlined  me-3">sentiment_satisfied</Link>
                                       <Link to="#" className="material-symbols-outlined  me-3">photo_camera</Link>
                                    </div>
                                 </form>
                              </div>
                           </div>
                        </Card.Body>
                     </Card> */}
                  </Col>
               </Row>
            </Row>
         </Container>
      </>
   )

}

export default FriendProfile;